export const ORDER_STATUS = {
    CASH: 'cash',
    COMPLETE: 'complete',
    COMPLETE_FROM_ASSIGNMENT: 'completeFromAssignment',
    COMPLETE_FROM_EXCHANGE: 'completeFromExchange',
    COMPLETE_FROM_GROUP_PURCHASE: 'completeFromGroupPurchase',
    COMPLETE_FROM_INVOICE: 'completeFromInvoice',
    COMPLETE_FROM_TRANSFER: 'completeFromTransfer',
    DRAFT: 'draft',
    DUPLICATE: 'duplicate',
    DUPLICATE_ORDER: 'duplicate_order',
    FAILED: 'failed',
    INCOMPLETE: 'incomplete',
    INVOICE_SENT: 'invoice_sent',
    OPEN: 'open',
    PAST_DUE: 'past_due',
    PAID: 'paid',
    PENDING: 'pending',
    PENDING_SEND: 'pending_send',
    PLAN: 'plan',
    REFUNDED: 'refunded',
    RELEASED: 'released',
    RESERVED: 'reserved',
};
export const ORDER_STATUS_LABEL = {
    [ORDER_STATUS.CASH]: 'Cash',
    [ORDER_STATUS.COMPLETE]: 'Complete',
    [ORDER_STATUS.COMPLETE_FROM_ASSIGNMENT]: 'Complete From Assignment',
    [ORDER_STATUS.COMPLETE_FROM_EXCHANGE]: 'Complete From Exchange',
    [ORDER_STATUS.COMPLETE_FROM_GROUP_PURCHASE]: 'Complete From Group Purchase',
    [ORDER_STATUS.COMPLETE_FROM_INVOICE]: 'Complete From Invoice',
    [ORDER_STATUS.COMPLETE_FROM_TRANSFER]: 'Complete From Transfer',
    [ORDER_STATUS.DRAFT]: 'Draft',
    [ORDER_STATUS.DUPLICATE]: 'Duplicate',
    [ORDER_STATUS.DUPLICATE_ORDER]: 'Duplicate Order',
    [ORDER_STATUS.FAILED]: 'Failed',
    [ORDER_STATUS.INCOMPLETE]: 'Incomplete',
    [ORDER_STATUS.INVOICE_SENT]: 'Invoice Sent',
    [ORDER_STATUS.OPEN]: 'Open',
    [ORDER_STATUS.PAST_DUE]: 'Past Due',
    [ORDER_STATUS.PAID]: 'Paid',
    [ORDER_STATUS.PENDING]: 'Pending',
    [ORDER_STATUS.PENDING_SEND]: 'Pending Send',
    [ORDER_STATUS.PLAN]: 'Payment Plan',
    [ORDER_STATUS.REFUNDED]: 'Refunded',
    [ORDER_STATUS.RELEASED]: 'Released',
    [ORDER_STATUS.RESERVED]: 'Reserved',
};
export const PAYMENT_TYPE = {
    CARD: 'card',
    CASH: 'cash',
    CHECK: 'check',
    COMP: 'comp',
    INVOICE: 'invoice',
    POS: 'pos',
    TEAM_CREDIT: 'team_credit',
    EXTERNAL: 'external',
    PAYROLL_DEDUCTION: 'payroll_deduction',
    E_TRANSFER: 'e_transfer',
    EXCHANGE: 'exchange',
    VOUCHER: 'voucher',
    RESERVED: 'reserved',
};
export const PAYMENT_TYPE_LABEL = {
    [PAYMENT_TYPE.CARD]: 'Card',
    [PAYMENT_TYPE.CASH]: 'Cash',
    [PAYMENT_TYPE.CHECK]: 'Check',
    [PAYMENT_TYPE.COMP]: 'Comp',
    [PAYMENT_TYPE.INVOICE]: 'Invoice',
    [PAYMENT_TYPE.POS]: 'POS',
    [PAYMENT_TYPE.TEAM_CREDIT]: 'Team Credit',
    [PAYMENT_TYPE.EXTERNAL]: 'External',
    [PAYMENT_TYPE.PAYROLL_DEDUCTION]: 'Payroll Deduction',
    [PAYMENT_TYPE.E_TRANSFER]: 'E Transfer',
    [PAYMENT_TYPE.EXCHANGE]: 'Exchange',
    [PAYMENT_TYPE.VOUCHER]: 'Voucher',
    [PAYMENT_TYPE.RESERVED]: 'Reserved',
};
export const ORDER_SOURCE = {
    BOX_OFFICE: 'box_office',
    TICKET_ASSIGNMENT: 'ticket_assignment',
    TICKET_EXCHANGE: 'ticket_exchange',
    TRANSFER: 'transfer',
    WEBSITE: 'website',
};
export const ORDER_SOURCE_LABEL = {
    [ORDER_SOURCE.BOX_OFFICE]: 'Box Office',
    [ORDER_SOURCE.TICKET_ASSIGNMENT]: 'Ticket Assignment',
    [ORDER_SOURCE.TICKET_EXCHANGE]: 'Ticket Exchange',
    [ORDER_SOURCE.TRANSFER]: 'Transfer',
    [ORDER_SOURCE.WEBSITE]: 'Website',
};
export const PRODUCT_TYPE = {
    FLEX_PACKAGES: 'flex_packages',
    SEASON_PACKAGES: 'season_packages',
    TICKETS: 'tickets',
    DEPOSIT: 'deposit',
    DYNAMIC_PRICING: 'dynamic_pricing',
    ACCESS_PASS: 'access_pass',
};
export const PRODUCT_TYPE_LABEL = {
    [PRODUCT_TYPE.FLEX_PACKAGES]: 'Flex Packages',
    [PRODUCT_TYPE.SEASON_PACKAGES]: 'Season Packages',
    [PRODUCT_TYPE.TICKETS]: 'Tickets',
    [PRODUCT_TYPE.DEPOSIT]: 'Deposit',
    [PRODUCT_TYPE.DYNAMIC_PRICING]: 'Dynamic Pricing',
    [PRODUCT_TYPE.ACCESS_PASS]: 'Access Pass',
};
